import React from 'react';
import useResizeObserver from 'use-resize-observer';

import {ArtifactVersionMetricBarChart} from './ArtifactVersionMetricBarChart';
import {ArtifactVersionMetricLineChart} from './ArtifactVersionMetricLineChart';
import type {ArtifactVersionMetricPlotReady} from './artifactVersionMetricPlotModel';
import {ArtifactVersionMetricScatterChart} from './ArtifactVersionMetricScatterChart';

type ArtifactVersionMetricChartProps = {
  plot: ArtifactVersionMetricPlotReady;
};

// Each chart type is its own component (mirroring weave's `Browse3/charts/`):
// bar renders via the shared visx `BarChart`, while line/scatter share a
// react-vis frame that matches the existing run line-plot stack.
export const ArtifactVersionMetricChart: React.FC<
  ArtifactVersionMetricChartProps
> = ({plot}) => {
  const {config} = plot;
  const {ref, height = 180, width = 1} = useResizeObserver<HTMLDivElement>();
  const plotHeight = Math.max(1, Math.floor(height));
  const plotWidth = Math.max(1, Math.floor(width));

  let chart: React.ReactNode = null;
  if (config.chartType === 'bar') {
    chart = <ArtifactVersionMetricBarChart plot={plot} height={plotHeight} />;
  } else if (config.chartType === 'scatter') {
    chart = (
      <ArtifactVersionMetricScatterChart
        plot={plot}
        width={plotWidth}
        height={plotHeight}
      />
    );
  } else {
    chart = (
      <ArtifactVersionMetricLineChart
        plot={plot}
        width={plotWidth}
        height={plotHeight}
      />
    );
  }

  return (
    <div className="flex h-full min-h-0 w-full flex-col bg-wb-surface">
      <div ref={ref} className="min-h-0 flex-1" style={{height: 0}}>
        {plotWidth > 0 && plotHeight > 0 && chart}
      </div>
    </div>
  );
};
